import { UserStatus, useUpdateUserGeneralInfoMutation } from '../../../../generated'
import { Box, IconButton, Typography } from '@mui/material'
import SaveRoundedIcon from '@mui/icons-material/SaveRounded'

// others
import { FormProvider, useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { updateDepartmentSchema } from '../../../validationSchema'
import { UpdateUserGeneralInfoForm } from '../../../interfaceTypes/forms'
import { UpdateDepartmentsProps } from '../../../interfaceTypes/props'

// components
import SelectDepartments from '../SelectDepartments'
import { Alert } from '../../common/Alert'
import OfficeAutoComplete from '../../offices/OfficeAutocomplete'

const UpdateUserGeneralInfo = ({ state, refetch }: UpdateDepartmentsProps) => {
  const { currentUser } = state ?? {}
  const { status, id, office } = currentUser ?? {}

  const { deptToUsers } = currentUser ?? {}
  const methods = useForm<UpdateUserGeneralInfoForm>({
    resolver: yupResolver(updateDepartmentSchema),
    defaultValues: {
      id,
      departmentIds: deptToUsers?.map(dept => dept?.departmentId || '') ?? [],
      office: {
        label: office?.name,
        value: office?.id
      }
    }
  })

  const { handleSubmit, setValue } = methods

  const [updateUserGeneralInfo, { loading }] = useUpdateUserGeneralInfoMutation({
    onError: error => {
      console.error(error)
    },
    onCompleted: data => {
      refetch?.()
      const { updateUserGeneralInfo } = data || {}
      const { user } = updateUserGeneralInfo || {}
      const { office } = user || {}
      Alert.success('User updated successfully!')
      setValue('office', { label: office?.name || '', value: office?.id || 0 })
    }
  })

  const onSubmit = async (data: UpdateUserGeneralInfoForm) => {
    const { office, ...rest } = data
    await updateUserGeneralInfo({
      variables: {
        user: {
          ...rest,
          officeId: office?.value
        }
      }
    })
  }

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Box pb={2}>
          <Box display="flex" alignItems="center" justifyContent="space-between">
            <Box flex={1}>
              <Typography variant="h5" fontSize="14px">
                General:
              </Typography>
            </Box>

            <IconButton type="submit" aria-label="save" disabled={status !== UserStatus.Active || loading}>
              <SaveRoundedIcon color={status === UserStatus.Active ? 'primary' : 'disabled'} />
            </IconButton>
          </Box>

          <SelectDepartments state={state} />

          <OfficeAutoComplete
            name="office"
            label="Location"
            currentOffice={office ? { id: office?.id, name: office?.name } : undefined}
            autoSelectOnTab
          />
        </Box>
      </form>
    </FormProvider>
  )
}

export default UpdateUserGeneralInfo
